import { pgTable, integer, timestamp, varchar, serial } from 'drizzle-orm/pg-core';

export const waInstance = pgTable('wa_instance', {
  id: serial().primaryKey(),
  created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
  slots: integer().notNull().default(0),
  connections: integer().notNull().default(0),
  host: varchar({ length: 255 }).notNull(),
});
